/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  Typography,
  Link
} from '@one-thd/sui-atomic-components';

export const StrikeThroughPriceDisclaimer = ({
  openPricingDisclaimer = false,
  setOpenPricingDisclaimer = () => { }
}) => {
  if (!openPricingDisclaimer) {
    return null;
  }
  return (
    <Drawer
      open={openPricingDisclaimer}
      onClose={() => setOpenPricingDisclaimer(false)}
    >
      <DrawerHeader title="Strikethrough Pricing" onClose={() => setOpenPricingDisclaimer(false)} />
      <DrawerBody>
        <Typography variant="body-base" component="div">
          <div className="sui-font-bold">
            Certain products on&nbsp;
            <Link href="https://www.homedepot.com" target="_blank">
              <span className="sui-font-bold">https://www.homedepot.com</span>
            </Link> and in our stores may display strikethrough price.
          </div>
          <div className="sui-pt-6 sui-text-justify">
            The strikethrough price may be (i) a price determined using the 90-day median price for the item (excluding sales, holiday campaigns, clearance, and other limited time promotions), (ii) the prevailing price of the product within the previous 90 days, (iii) the most recent price of the product, or (iv) the manufacturer’s suggested retail price (MSRP) or minimum advertised price (MAP), none of which may reflect a price actually paid by a consumer or a prevailing market price.  Based on savings from the strikethrough price, product displays may also show a “Save” dollar value and/or a percentage off.
          </div>
        </Typography>
      </DrawerBody>
    </Drawer>
  );
};

StrikeThroughPriceDisclaimer.propTypes = {
  openPricingDisclaimer: PropTypes.bool,
  setOpenPricingDisclaimer: PropTypes.func,
};
